import styled from '@emotion/styled';
import { COLORS_GRAYS } from '../../styles/emotion/colors3';
import { MEDIA_QUERY, SPACING } from '../../styles/emotion';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  ${MEDIA_QUERY.MOBILE} {
    border-bottom: 1px solid ${COLORS_GRAYS.BLACK_050};
  }
`;

export const Title = styled.h3`
  ${MEDIA_QUERY.MOBILE} {
    display: none;
  }
`;

export const IosBadgeLink = styled.a`
  text-align: center;
  padding: 0 ${SPACING.XXS};
  img {
    padding-bottom: 10px;
    max-width: 150px;
    height: 60px;
  }
`;
